const knownTypes = new Set(['photo', 'video', 'audio', 'gif'])
const aliases = { image: 'photo', picture: 'photo', animated_gif: 'gif' }

export function mediaTypeOf(item) {
  for (const candidate of [item?.type, item?.media_type]) {
    if (typeof candidate !== 'string') continue
    const value = candidate.trim().toLowerCase()
    const normalized = aliases[value] || value
    if (knownTypes.has(normalized)) return normalized
  }
  return 'unknown'
}

export function mediaDuration(item) {
  if (!['video', 'audio'].includes(mediaTypeOf(item))) return ''
  const value = item?.duration
  if (value == null || value === '' || typeof value === 'boolean') return ''
  const seconds = Math.floor(Number(value))
  if (!Number.isFinite(seconds) || seconds < 0) return ''
  return `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`
}

export function mediaTypeCounts(items = []) {
  const counts = { photo: 0, video: 0, audio: 0, gif: 0, unknown: 0 }
  for (const item of items) counts[mediaTypeOf(item)] += 1
  return Object.entries(counts).filter(([, count]) => count > 0)
}

export function applyMediaUpdate(items, updated, includeHidden = false) {
  if (!items || !updated?.id) return items
  return items
    .map((item) => String(item.id) === String(updated.id) ? { ...item, ...updated } : item)
    .filter((item) => includeHidden || !item.is_hidden)
}
